
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.75 5a.75.75 0 00-1.5 0v8.69l-3.095-3.095a.75.75 0 10-1.06 1.06l4.375 4.375a.747.747 0 001.06 0l4.375-4.375a.75.75 0 00-1.06-1.06l-3.095 3.094V5zM5 14.75a.75.75 0 01.75.75v1.75a1 1 0 001 1h10.5a1 1 0 001-1V15.5a.75.75 0 011.5 0v1.75a2.5 2.5 0 01-2.5 2.5H6.75a2.5 2.5 0 01-2.5-2.5V15.5a.75.75 0 01.75-.75z"}})])
          )
        }
      }
    